export default "__VITE_PUBLIC_ASSET__299ee268__"